import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "profile-page" }
const _hoisted_2 = { class: "profile-picture" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "username"
}
const _hoisted_5 = {
  key: 1,
  class: "joined"
}

import { ref, onMounted, computed } from 'vue'
import { getAuth, updatePassword, onAuthStateChanged, User } from 'firebase/auth'
import { formatDistanceToNow } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const auth = getAuth()
const user = ref<User | null>(null)
const newPassword = ref('')
const message = ref('')
const error = ref('')
const loading = ref(false)

const joinedText = computed(() => {
  if (user.value?.metadata?.creationTime) {
    const createdAt = new Date(user.value.metadata.creationTime)
    return `Joined ${formatDistanceToNow(createdAt, { addSuffix: false })} ago`
  }
  return ''
})

onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    if (currentUser) {
      user.value = currentUser
    }
  })
})

const changePassword = async () => {
  message.value = ''
  error.value = ''

  if (auth.currentUser) {
    loading.value = true
    try {
      await updatePassword(auth.currentUser, newPassword.value)
      message.value = 'Password changed successfully.'
      newPassword.value = ''
    } catch (err: any) {
      error.value = err.message
    } finally {
      loading.value = false
    }
  } else {
    error.value = 'User is not authenticated.'
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (user.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: `https://robohash.org/${user.value.email}`
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (user.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(user.value.email), 1))
      : _createCommentVNode("", true),
    (joinedText.value)
      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(joinedText.value), 1))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "profile-stats" }, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, "10"),
        _createElementVNode("p", null, "Dishes")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, "2"),
        _createElementVNode("p", null, "Milestones ")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, "23"),
        _createElementVNode("p", null, "Logs")
      ])
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "profile-options" }, [
      _createElementVNode("button", { class: "button primary" }, "Change Password")
    ], -1))
  ]))
}
}

})